import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { getSuggestedDoctors } from '../../core';
import { CustomLoader } from '../../components/basic/loader';
import DoctorIcon from '../../assets/icons/doctor_vector_black.svg';

export const Suggestions = () => {
  const navigate = useNavigate();
  const { productId, endVertexId } = useParams();
  const doctors = useQuery({
    queryKey: ['doctors-suggestions', endVertexId, productId, 1],
    queryFn: async () => {
      const res = await getSuggestedDoctors(
        parseInt(endVertexId ?? '-1'),
        parseInt(productId ?? '-1'),
        1
      );
      return res.data.data;
    }
  });
  if (doctors.isLoading) {
    return <CustomLoader />;
  }
  return (
    <div className="py-5 px-5">
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {doctors.data.map((doctor: any) => {
        return (
          <div
            key={doctor.id}
            className="shadow-lg rounded-lg px-5 py-3 flex items-center justify-around cursor-pointer mb-3"
            onClick={() => navigate(`/reserve/${doctor.doctor_user_id}`)}>
            <img className="w-[64px]" src={DoctorIcon} alt="" />
            <div className="flex text-center flex-col">
              <p className="text-base text-[--rs-gray-700]">{doctor.doctor_name_family}</p>
              <br />
              <p className="text-sm">متخصص در درمان: {doctor.expertise_product_title_support}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
